import {
  Building2,
  CalendarDays,
  CalendarPlus,
  Clock3,
  CreditCard,
  Home,
  LayoutDashboard,
  ReceiptText,
  Settings,
  Sparkles,
  Stethoscope,
  UserRound,
  type LucideIcon,
} from "lucide-react";
import type { UserRole } from "../api/types";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
}

export const AREA_SEGMENT: Record<UserRole, string> = {
  PATIENT: "pasien",
  THERAPIST: "therapist",
  TENANT_ADMIN: "admin",
  SUPER_ADMIN: "platform",
};

export const NAV_BY_ROLE: Record<UserRole, NavItem[]> = {
  PATIENT: [
    { to: "/pasien", label: "Beranda", icon: Home, end: true },
    { to: "/pasien/booking", label: "Booking", icon: CalendarPlus },
    { to: "/pasien/appointments", label: "Janji Temu", icon: CalendarDays },
    { to: "/pasien/history", label: "Riwayat", icon: ReceiptText },
    { to: "/pasien/profile", label: "Profil", icon: UserRound },
  ],
  THERAPIST: [
    { to: "/therapist", label: "Hari Ini", icon: CalendarDays, end: true },
    { to: "/therapist/jadwal", label: "Jadwal", icon: Clock3 },
    { to: "/therapist/appointments", label: "Appointment", icon: LayoutDashboard },
    { to: "/therapist/profile", label: "Profil", icon: UserRound },
  ],
  TENANT_ADMIN: [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/admin/bookings", label: "Bookings", icon: CalendarDays },
    { to: "/admin/therapists", label: "Therapists", icon: Stethoscope },
    { to: "/admin/services", label: "Layanan", icon: Sparkles },
    { to: "/admin/schedule", label: "Jadwal", icon: Clock3 },
    { to: "/admin/payments", label: "Pembayaran", icon: CreditCard },
    { to: "/admin/settings", label: "Pengaturan", icon: Settings },
  ],
  SUPER_ADMIN: [
    { to: "/platform", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/platform/tenants", label: "Tenants", icon: Building2 },
    { to: "/platform/profile", label: "Profil", icon: UserRound },
  ],
};
